<template>
  <!-- 门禁智能系统解决方案 -->
  <div class="content_app">
    <Banner :banner-h="h1" :banner-p="P1" :banner-img="Img1"></Banner>

    <scroll-animate>
      <div class="product_hardware"
           style="background-color: white; margin-top: 30px">
        <div class="product_hardware_video_text">
          <div class="video_box">
            <video
                src="@/assets/video/glassDoorHandleSmartLock.mp4"
                autoplay
                loop
                muted
                controlslist="nofullscreen nodownload noremoteplayback"
                @contextmenu.prevent>
            </video>
          </div>
          <div class="product_hardware_text">
            <div class="hardware_text">
              <h1>{{ $t('services.glassDoorHandleSmartLock.productOverview') }}</h1>
              <p>{{ $t('services.glassDoorHandleSmartLock.productHardwareDesc') }}</p>
            </div>
            <div class="hardware_image">
              <div class="hardware_image_item">
                <img src="@/assets/img/service/access/lashousuochanpin/tu1.jpg"/>
              </div>
              <div class="hardware_image_item">
                <img src="@/assets/img/service/access/lashousuochanpin/tu2.jpg"/>
              </div>
              <div class="hardware_image_item">
                <img src="@/assets/img/service/access/lashousuochanpin/tu3.jpg"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroll-animate>
    <scroll-animate>
      <div class="system_service_introduced"
           style="background-color: #f2f2f2; padding-bottom: 0; width: 60%">
        <img src="@/assets/img/service/access/access4_gray.png">
      </div>
    </scroll-animate>
    <scroll-animate>
      <div class="product_hardware"
           style="white-space: pre; overflow-wrap: break-word; ">
        <h1>{{ $t('services.glassDoorHandleSmartLock.featureOverview') }}</h1>
        <p>{{ $t('services.glassDoorHandleSmartLock.featureOverviewDesc') }}</p>
      </div>
    </scroll-animate>
    <scroll-animate>
      <div class="involved_products">
        <h1>{{ $t('services.glassDoorHandleSmartLock.involvedProducts') }}</h1>
        <section class="disp-content core_box">
          <ul class="content_ul">
            <li v-for="(item, index) in deviceData" :key="index">
            <span class="content-img">
              <img :src="item.image"/>
            </span>
              <h3>
                {{ $t(`services.glassDoorHandleSmartLock.devices.${item.key}.title`) }}
              </h3>
              <p>{{ $t(`services.glassDoorHandleSmartLock.devices.${item.key}.description`) }}</p>
              <span class="span_jiantou el-icon-right" @click="deviceItemClick(item)">
            </span>
              <em></em>
              <em></em>
            </li>
          </ul>
        </section>
      </div>
    </scroll-animate>

  </div>

</template>

<script>
import Banner from "@/components/banner.vue";
import {entranceGuard} from "@/assets/js/entranceGuard";
import {displayCase} from "@/assets/js/displayCase";
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  components: {ScrollAnimate, Banner},
  mounted() {
  },
  methods: {
    deviceItemClick(data) {
      let productsData = null
      switch (data.category) {
        case "displayCase":
          productsData = displayCase
          break
        case "entranceGuard":
          productsData = entranceGuard
          break
      }
      if (productsData) {
        for (const item of productsData) {

          if (item.categoryName == data.dataKey) {
            const categoryData = {name: item.categoryName}
            categoryData.options = []
            item.catgItem.forEach((it) => {
              categoryData.options.push(it)
            })
            console.log(categoryData)
            sessionStorage.setItem("product", JSON.stringify(categoryData))
            this.$router.push({
              name: "productShow",
            })
            break
          }
        }
      }
    }
  },
  data() {
    return {
      h1: this.$t('services.glassDoorHandleSmartLock.title'),
      P1: this.$t('services.glassDoorHandleSmartLock.description'),
      Img1: require("@/assets/img/banner-bg/shanmai1.jpg"),

      // 设备架构数据
      deviceData: [
        {
          image: require("@/assets/img/service/access/lashousuo.png"),
          dataKey: this.$t('entranceGuard.categoryName.wirelessLock'),
          key: "pullLock",
          category: "entranceGuard"
        }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/css/serviceCommonCss";
</style>
